import { IRawProducts } from '@/interfaces';

export default (): IRawProducts => {
  return [];
};
